export default class AxsSdk {
    constructor() {
        const isAxsSdkPage = document.getElementById('axsid_login');
        if (isAxsSdkPage) {
            this.init = this.init.bind(this);
            this.init();
        }
    }

    init() {
        const axsSdkParams = document.querySelector('#axsSdkParams').value;
        const axsSdkUrl = document.querySelector('#axsSdkUrl').value;
        const returnUrl = document.querySelector('#returnUrl').value;

        var params;
        if (axsSdkParams) {
            params = JSON.parse(atob(axsSdkParams));
            params.loginHandler = handleAXSLogin;
        }

        function handleAXSLogin(err, status, user) {
            if (!user) {
                return;
            }

            var xhr = new XMLHttpRequest();
            var url = window.location.origin + "/Account/AxsHandler";
            xhr.open("POST", url, true);
            xhr.setRequestHeader("content-type", "application/json");
            xhr.onreadystatechange = function () {
                if (xhr.response === "\"signin\"") {
                    window.location.href = window.location.origin + returnUrl;
                }
                if (xhr.response === "\"purchase\"") {
                    window.location.href = window.location.origin + "/Cart/Index";
                }
                if (xhr.response === "\"linkingSuccess\"") {
                    window.location.href = window.location.origin + "/Account/LinkingSuccess";
                }
            };

            if (document.querySelector('#axsid_main_container')) {
                setTimeout(function () {
                    let axsIdContainer = document.getElementById("axsid_main_container");
                    //For IE9
                    let showSpinnerClassName = "show-spinner";
                    let classNames = axsIdContainer.className.split(" ");
                    if (classNames.indexOf(showSpinnerClassName) === -1) {
                        axsIdContainer.className += " " + showSpinnerClassName;
                    }

                    let firstChild = axsIdContainer.children[0];
                    //For IE9
                    let skFoldingCubeName = "sk-folding-cube";
                    let firstChildClassNames = firstChild.className.split(" ");
                    if (firstChildClassNames.indexOf(skFoldingCubeName) === -1) {
                        firstChild.className += " " + skFoldingCubeName;
                    }

                    firstChild.appendChild(createCubeSpinner(1));
                    firstChild.appendChild(createCubeSpinner(2));
                    firstChild.appendChild(createCubeSpinner(4));
                    firstChild.appendChild(createCubeSpinner(3));
                }, 0);
            }

            xhr.send(JSON.stringify(user));
        }

        function createCubeSpinner(index) {
            const element = document.createElement('div');
            element.setAttribute('class', `sk-cube${index} sk-cube`);
            element.setAttribute('data-reactid-axsid', `.0.0.${index - 1}`);

            return element;
        }

        function useCustomEventPolyfillForIE() {
            if (typeof window.CustomEvent === "function") return false;

            function CustomEvent(event, params) {
                params = params || { bubbles: false, cancelable: false, detail: undefined };
                var evt = document.createEvent('CustomEvent');
                evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
                return evt;
            }

            CustomEvent.prototype = window.Event.prototype;
            window.CustomEvent = CustomEvent;
        }

        let axsID;
        const script = document.createElement('script');
        script.src = axsSdkUrl;
        script.onload = script.onreadystatechange = function () {
            window.AXSIDReady = function () {
                useCustomEventPolyfillForIE();
                axsID = new window.AXSID(params);
                axsID.show();
            }
        }
        document.body.appendChild(script);
    }
}
